export default __webpack_public_path__ + "static/media/casino.9566a866.webp";